<app-header-tela [titulo]="'Dados Cartão de Crédito'" exibirFechar="true" (fechou)="fecheTela()" ></app-header-tela>

<div class="mt-3" *ngIf="pedido">
    <div class="row">
      <div class="col">
        <div class="alert alert-danger mb-2" role="alert" *ngIf="msgErro">
          <i class="fas fa-exclamation-triangle"></i> {{msgErro}}
        </div>

        <ng-container *ngIf="gatewayMercadoPago()">
          <app-cad-cartao-mercadopago #dadosCartaoMercadoPago [pedido]="pedido" (onGerouToken)="gerouTokenCartao($event)">

          </app-cad-cartao-mercadopago>
        </ng-container>

        <ng-container *ngIf="gatewayPagSeguro()">
          <cad-cartaocredito-pag-seguro #dadosCartao [pedido]="pedido"></cad-cartaocredito-pag-seguro>
        </ng-container>

        <ng-container *ngIf="gatewayPagCielo()">
          <app-cad-cartao-cielo #ctlDadosCartaoCielo [pedido]="pedido"></app-cad-cartao-cielo>
        </ng-container>

        <ng-container *ngIf="gatewayPagarme()">
          <app-cad-cartao-pagarme #ctlDadosCartaoPagarme [pedido]="pedido"></app-cad-cartao-pagarme>
        </ng-container>


      </div>
    </div>
    <div class="row mt-1" *ngIf="gatewayPagSeguro() || gatewayPagarme() || gatewayPagCielo()">
      <div class="col-12">
        <h4 class="mb-2 mt-1">Endereço Dono do Cartão</h4>
      </div>
      <div class="col-12 mt-1" *ngIf="!obrigarEndereco">
        <label>Mesmo Endereço de Entrega?</label>&nbsp;
        <kendo-switch [(ngModel)]="usarEnderecoDeEntrega" (ngModelChange)="alterouUsarEnderecoDeEntrega()"
                      [onLabel]="'Sim'"
                      [offLabel]="'Não'"></kendo-switch>
      </div>
      <div class="col-12 mt-1" *ngIf="!usarEnderecoDeEntrega">
        <app-form-endereco [buscouUmEndereco]="true" [exibirBotao]="false"
                            [pontoReferencia]="false"
                           #formEndereco [ignorarConfigEmpresa]="true" [cepObrigatorio]="true"></app-form-endereco>
      </div>
    </div>

    <footer class="footer">
      <div>
        <div class="row">
          <div class="col">
            <button class="btn btn-blue btn-block" type="submit" id="confimarCartao"  [hidden]="gatewayMercadoPago()"
                    [disabled]="processandoDados" (click)="salvarCartao()">
              <i class="k-icon k-i-loading" *ngIf="processandoDados"></i>
              Confirmar Cartão</button>
          </div>
        </div>
      </div>
    </footer>
</div>
